module.exports = __webpack_public_path__ + "static/media/invite_share.c2a65e8b.jpg";